import React from 'react';

import './App.css';
import Home from './components/pages/Home';
import './styles/hamburger.css';

function App() {
  return (
    <Home />
  );
}

export default App;
